import { render } from "./MessageText.vue?vue&type=template&id=24841d3c&scoped=true&ts=true"
import script from "./MessageText.vue?vue&type=script&lang=ts"
export * from "./MessageText.vue?vue&type=script&lang=ts"

import "./MessageText.vue?vue&type=style&index=0&id=24841d3c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24841d3c"]])

export default __exports__